import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.css'
import { isEmbeddedCheckout } from './utils/embedMode'

if (isEmbeddedCheckout()) {
  document.documentElement.classList.add('ep-embed')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
